module.exports = __webpack_public_path__ + "img/科尔本施密特.png";